import * as React from 'react';
import { useEffect, useState, useMemo } from 'react';
import BentoBox from '../BentoBox';
import { BentoBox as BentoBoxType } from 'types/generated';
import { fetchBentoBoxes } from '@/clients/BentoBoxUtils';
import { PlaceholderBox } from './PlaceHolderBox';

interface BentoBoxItem {
  sys: {
    id: string;
  };
}

interface BentoBoxId {
  data: {
    items: BentoBoxItem[];
  };
}

const LayoutTen = ({ data }: BentoBoxId) => {
  const bentoBoxIds = useMemo(() => data?.items?.slice(0, 3).map((item: BentoBoxItem) => item?.sys?.id) || [], [data]);

  const [bentoBoxes, setBentoBoxes] = useState<BentoBoxType[]>([]);

  useEffect(() => {
    const fetchBox = async () => {
      if (bentoBoxIds.length) {
        const fetchedBoxes = await fetchBentoBoxes(bentoBoxIds);
        if (fetchedBoxes) {
          setBentoBoxes(fetchedBoxes);
        }
      }
    };
    fetchBox();
  }, [bentoBoxIds]);

  if (bentoBoxes.length < 3) {
    return (
      <>
        {/* Mobile view: show only first BentoBox */}
        <div className="block min-h-[70vh] w-full md:hidden">
          <PlaceholderBox />
        </div>
        {/* Desktop view */}
        <div className="hidden min-h-[70vh] w-full flex-col md:flex">
          <div className="w-full" style={{ height: 'calc(((100% - 16px) / 3) * 2)' }}>
            <PlaceholderBox />
          </div>
          <div style={{ height: '16px' }} />
          <div className="flex w-full" style={{ height: 'calc((100% - 16px) / 3)' }}>
            <div className="h-full" style={{ width: 'calc(((100% - 16px) / 5) * 3)' }}>
              <PlaceholderBox />
            </div>
            <div style={{ width: '16px' }} />
            <div className="h-full" style={{ width: 'calc(((100% - 16px) / 5) * 2)' }}>
              <PlaceholderBox />
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {/* Mobile view: show only first BentoBox */}
      <div className="block min-h-[70vh] w-full md:hidden">
        <BentoBox box={bentoBoxes[0]} />
      </div>

      {/* Desktop view */}
      <div className="hidden min-h-[70vh] w-full flex-col md:flex">
        <div className="w-full" style={{ height: 'calc(((100% - 16px) / 3) * 2)' }}>
          <BentoBox box={bentoBoxes[0]} />
        </div>
        <div style={{ height: '16px' }} />
        <div className="flex w-full" style={{ height: 'calc((100% - 16px) / 3)' }}>
          <div className="h-full" style={{ width: 'calc(((100% - 16px) / 5) * 3)' }}>
            <BentoBox box={bentoBoxes[1]} />
          </div>
          <div style={{ width: '16px' }} />
          <div className="h-full" style={{ width: 'calc(((100% - 16px) / 5) * 2)' }}>
            <BentoBox box={bentoBoxes[2]} />
          </div>
        </div>
      </div>
    </>
  );
};

export default LayoutTen;
